export default __webpack_public_path__ + "static/media/downGreen.b6d2549a.svg";